import Vue from 'vue';

const EventBus = new Vue({
    data() {
        return {
            // 0：未登录 1：登录 -1：初始状态
            isLogin: -1,
            indexScroll: 0,
            tbDialogInfo: {
                visible: false,
                jumpFunc: null
            }
        };
    }
});

export default EventBus;
